import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const testOnboardingWebhook = (axios: IAxiosInstance) => {
  return async ({
    onboardingWebhook,
    userType,
    test,
    usePrimary,
  }: ISchema["#/definitions/ITestOnboardingWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ITestOnboardingWebhookResponse"]
    >(`/api/testOnboardingWebhook${getUsePrimaryUrlParams(usePrimary)}`, {
      onboarding_webhook: onboardingWebhook,
      user_type: userType,
      test,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
